import React, { useEffect, useRef } from "react";

// Cloudflare Turnstile (existing-widget flow). Explicit render so it works in
// the SPA; token is returned via onVerify and is single-use. The backend calls
// siteverify — the browser never does. Renders nothing if no site key is set.
const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;
let scriptPromise = null;

function loadScript() {
  if (typeof window !== "undefined" && window.turnstile) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    s.async = true;
    s.defer = true;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
  return scriptPromise;
}

export default function Turnstile({ onVerify, action, className }) {
  const ref = useRef(null);
  const widgetId = useRef(null);

  useEffect(() => {
    if (!SITE_KEY) return undefined;
    let cancelled = false;
    loadScript().then(() => {
      if (cancelled || !ref.current || !window.turnstile) return;
      widgetId.current = window.turnstile.render(ref.current, {
        sitekey: SITE_KEY,
        action,
        callback: (token) => onVerify && onVerify(token),
        "error-callback": () => onVerify && onVerify(""),
        "expired-callback": () => onVerify && onVerify(""),
      });
    }).catch(() => {});
    return () => {
      cancelled = true;
      try { if (widgetId.current && window.turnstile) window.turnstile.remove(widgetId.current); } catch { /* noop */ }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!SITE_KEY) return null;
  return <div ref={ref} className={className} data-testid="turnstile-widget" />;
}

export const TURNSTILE_ENABLED = Boolean(SITE_KEY);
